// Title and intro for the subscription disclosure modal. The terms, steps
// and agreement statement live in acknowledgmentCopy.js, which is
// dependency-free and mirrored on the server.
export { DISCLOSURE_VERSION } from './acknowledgmentCopy';

export function isSubscriptionProduct(product) {
  return product?.productType?.toLowerCase() === 'subscription';
}

// "plan" for a plan that later becomes a subscription, "subscription" for
// one bought outright. Keeps every sentence honest for either kind.
export function productNoun(product) {
  return isSubscriptionProduct(product) ? 'subscription' : 'plan';
}

function patientLabel(patient) {
  return [patient?.firstName, patient?.lastName].filter(Boolean).join(' ');
}

// "Your Smile Care Plan for Jane Doe, Explained". The product name is used
// as-is so a renamed or added plan product reads correctly without a code change.
export function disclosureTitle({ product, patient }) {
  const name = product?.name || 'Subscription';
  const who = patientLabel(patient);

  return who ? `Your ${name} for ${who}, Explained` : `Your ${name}, Explained`;
}

export function disclosureIntro({ product }) {
  return isSubscriptionProduct(product)
    ? 'Before we take payment, here is exactly how your subscription works.'
    : 'Before we take payment, here is exactly what your plan turns into.';
}
